import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Kund from "./Sammanfattning/Kund";
import Kontkat from "./Sammanfattning/Kontkat";
import Avtal from "./Sammanfattning/Avtal";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();

    return (
       <div> 
            <form className={classes.root}>
                <div>
                    <div>
                        <Kund currentKund={props.newAvtal.Kund} step={props.step} />
                    </div>
                    <div style={{padding: '15px'}}>
                        <Divider />
                    </div>
                    <div>
                        <Kontkat Kontkat={props.newAvtal.kontakt} step={props.step} />
                    </div>
                    <div style={{padding: '15px'}}>
                        <Divider />
                    </div>
                    <div>
                    <Avtal Avtal={props.newAvtal.Avtal} step={props.step} />
                    </div>
                    <div style={{padding: '15px'}}>
                        <Divider />
                    </div>
                </div>
            </form>
        </div>
    );
}